<template lang="html">
  <b-navbar class="fixed-top print_hide" toggleable="md" type="dark" >
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <a href="#" style="text-decoration: none;color:white;"  @click="$router.go(-1)"><i class="menu-icon mdi mdi-chevron-left"></i> {{ $t('back') }}</a>
      <b-navbar-nav class="header-links">

      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template slot="button-content">
            <div class="count-indicator">
              <div class="top-profile-name float-left" style="padding-right: 11px;">
                <div v-if="$store.state.user.data" class="name">{{$store.state.user.data.firstName}} {{$store.state.user.data.lastName}}</div>
                <div v-if="$store.state.user.data" class="designation" style="font-size: 11px;text-align: right;">{{ $t($store.state.user.data.role) }}</div>
                <!--<div class="badge badge-teal mx-auto mt-3">Online</div>-->
              </div>
              <!--<img class="img-xs float-left rounded-circle" style="font-size: 30px;" src="../../assets/images/baker.png" >-->
              <!--<span class="count">4</span>-->
            </div>
          </template>
          <!--<b-dropdown-item href="#">Profile</b-dropdown-item>-->
          <b-dropdown-item @click="signOut">{{$t('Signout')}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <div class="locale-changer mt-2">
          <b-dropdown variant="light" right size="sm" :text="$i18n.locale.toUpperCase()">
            <b-dropdown-item v-for="(lang, i) in locales" v-bind:key="i" @click="setLocale(lang.value)"> {{ lang.label }}</b-dropdown-item>
          </b-dropdown>
        </div>
        <!--<b-nav-item href="#"><i class="img-xs rounded-circle mdi mdi-account-circle" style="font-size: 21px;" ></i></b-nav-item>-->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script lang="js">
export default {
  data () {
    return {
      locales: [
        {label: 'English', value: 'en'},
        {label: 'Ελληνικά', value: 'gr'},
        // {label: 'Russian', value: 'ru'},
        {label: 'Bulgarian', value: 'bg'},
        // {label: 'Spanish', value: 'es'},
        // {label: 'German', value: 'de'},
        // {label: 'Croatian', value: 'cr'},
        // {label: 'French', value: 'fr'},
        // {label: 'Italian', value: 'it'},
        {label: 'Dutch', value: 'nl'}
        // {label: 'Danish', value: 'da'}
        // {label: 'Norwegian', value: 'no'},
        // {label: 'Portuguese', value: 'pt'},
        // {label: 'Swedish', value: 'se'}
      ]
    }
  },
  methods: {
    setLocale (value) {
      // this.$store.state.locale = value
      this.$i18n.locale = value
      this.$store.dispatch('setLocale', value)
    },
    signOut () {
      var self = this
      this.$firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({
            name: 'LogIn'
          }).then(() => {
            self.$store.dispatch('resetState')
          })
        })
    }
  }
}
</script>

<style lang="scss">
.app-header {
}
.locale-changer .btn.dropdown-toggle.btn-light {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppHeader.vue